import React, { useState, useEffect } from 'react';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem('cookie_consent');
    if (!accepted) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        background: '#1f2937',
        color: '#e5e7eb',
        padding: '16px 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '16px',
        flexWrap: 'wrap',
        fontSize: '14px',
        boxShadow: '0 -2px 10px rgba(0,0,0,0.15)',
      }}
    >
      <p style={{ margin: 0, maxWidth: '700px', lineHeight: '1.5' }}>
        We use cookies to improve your experience and analyse site traffic. By continuing to use this site you accept our use of cookies.
      </p>
      <button
        data-testid="cookie-accept-btn"
        onClick={handleAccept}
        style={{
          background: '#059669',
          color: 'white',
          border: 'none',
          padding: '8px 24px',
          borderRadius: '6px',
          cursor: 'pointer',
          fontSize: '14px',
          fontWeight: '600',
          whiteSpace: 'nowrap',
          flexShrink: 0,
        }}
      >
        Accept
      </button>
    </div>
  );
};

export default CookieConsent;
